<template >
  <div class="ly-card message-group">
    <div class="lf">
      <h3>用户组</h3>
      <ul>
        <li v-for="item in userGroup" :key="item.id" @click="clickItem(item)">{{item.group_name}}</li>
      </ul>
      <div class="btn-bottom">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addGroup">自建用户组</el-button>
      </div>
    </div>
    <div class="rg" v-if="curItem.id">
      <el-button type="primary" @click.native="dialogVisible = true">添加组员</el-button>
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
      >
        <template v-slot:action="row">
          <el-button @click="delRow(row)" type="danger" size="mini">移除</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog title="添加组员" :visible.sync="dialogVisible" width="600px">
      <el-select
        v-model="selValue"
        multiple
        filterable
        remote
        value-key="id"
        placeholder="请输入关键词"
        :remote-method="remoteMethod"
        :loading="selLoading"
        class="width-full"
      >
        <el-option
          v-for="item in selOptions"
          :key="item.id"
          :label="item.username"
          :value="item.id"
        ></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Option, Select } from 'element-ui';
import { message, sys } from '@/api';
import LyTable from '@/components/LyTable';

export default {
  name: 'MessageGroup',
  components: {
    ElDialog: Dialog,
    LyTable,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      template_name: '',
      curItem: {},
      dialogVisible: false,
      ruleForm: {
        template_type: '',
        template_name: '',
        template_content: '',
        template_remark: ''
      },
      rules: {
        template_type: [{ required: true, message: '请选择模板类型', trigger: 'change' }],
        template_remark: [{ required: true, message: '请输入申请说明', trigger: 'blur' }],
        template_name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        template_content: [{ required: true, message: '请输入模板内容', trigger: 'blur' }]
      },
      searchFormData: {
        group_id: ''
      },
      getTableData: sys.getrRegisterUser,
      tableHeader: [
        {
          option: {
            type: 'index'
          }
        },
        {
          value: 'name',
          name: '学员姓名'
        },
        {
          value: 'z',
          name: '家长姓名'
        },
        {
          value: 'x',
          name: '家长电话'
        },
        {
          value: 'action',
          name: '操作',
          option: {
            width: '160px'
          }
        }
      ],
      selOptions: [],
      selLoading: false,
      selValue: '',
      userGroup: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      message.smsUserGroup().then(res => {
        // 用户分组
        if (res && res.data) {
          this.userGroup = res.data.user_group_list;
        }
      });
    },
    addGroup() {
      this.$prompt('请输入用户组名称', '提示', {
        inputPattern: /^\S+$/,
        inputErrorMessage: '用户组名称不能为空'
      })
        .then(({ value }) => {
          console.log(value);
        })
        .catch(() => {});
    },
    clickItem(item) {
      this.curItem = item;
      this.searchFormData.group_id = item.id;
      this.$nextTick(() => {
        this.search();
      });
    },
    search() {
      this.$refs.lyTable.setData();
    },
    delRow(item) {
      console.log(item);
    },
    async remoteMethod(query) {
      const res = await sys.queryRoleUsers({
        params: {
          username: query
        },
        id: this.curItem.id
      });
      if (res && res.data) {
        this.selOptions = res.data.list;
      }
    }
  }
};
</script>
<style lang="less">
.message-group {
  display: flex;
  height: calc(100vh - @navBarTopHeight - @navBarTagsHeight - 10px);
  overflow: auto;
  .lf {
    width: 220px;
    height: 100%;
    background: #fff;
    border-right: 1px solid #ccc;
    overflow: auto;
    position: relative;
    padding-bottom: 40px;
    padding-right: 10px;
    h3 {
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
    }
    .btn-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      text-align: center;
    }
    ul {
      padding-left: 10px;
      li {
        list-style: none;
        display: flex;
        cursor: pointer;
        font-size: 15px;
        padding: 10px 5px;
        align-items: center;
        border-bottom: 1px solid #ccc;
      }
    }
  }
  .rg {
    flex: 1;
    margin-left: 10px;
    .content {
      border-bottom: 1px solid #ccc;
      padding: 10px 0;
      p {
        text-indent: 30px;
      }
    }
    .show-list .info {
      ul {
        li {
          list-style: none;
          margin: 20px 0;
          > .title {
            display: inline-block;
            min-width: 100px;
            font-size: 16px;
          }
          .content {
            color: #333;
            font-size: 14px;
          }
        }
      }
    }
    .input-flex {
      display: flex;
      .el-input {
        margin-right: 20px;
        width: 202px;
      }
    }
    .bottom > div {
      margin: 20px 0;
    }
  }
  .tags {
    .el-button {
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
